import { Component, OnInit } from '@angular/core';
import { PopoverController, IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'export-to-file-popover',
  templateUrl: './export-to-file-popover.component.html',
  styleUrls: ['./export-to-file-popover.component.scss'],
  standalone: true,
  imports: [IonicModule, TranslateModule]
})
export class ExportToFilePopoverComponent implements OnInit {

  constructor(private popoverCtrl: PopoverController) { }

  ngOnInit(): void {
  }
  dismissPopover(value: string) {
    return this.popoverCtrl.dismiss(value);
  }

}
